import React, {Component} from 'react';

import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';

import no_workingMemoryNumbersIntro from 'assets/sounds/no/intros/workingmemory-numbers-intro.mp3';
import nn_workingMemoryNumbersIntro from 'assets/sounds/nn/intros/workingmemory-numbers-intro.mp3';
import strings from 'strings';
import {TYPES} from '../../constants/index';

class Intro extends Component {
	constructor(props) {
		super(props);
		switch (strings.getLanguage()) {
			case 'nn':
				this.audio = nn_workingMemoryNumbersIntro;
				break;
			case 'no':
			default:
				this.audio = no_workingMemoryNumbersIntro;
				break;
		}
	}

	render() {
		const {ageGroup, testKeyType} = this.props;

		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.wsn_intro1}
					<br />
					{strings.wsn_intro2}
				</p>
				{!isNormingTest && (
					<ReadyButton onReadyChange={this.props.setReady} />
				)}
			</>
		);
	}
}

export default Intro;
